/**
 * Keep in sync with backend/utils/tunePageLayout.js — normalizeTuneSourceUrl.
 * Ensures “View original” and notation scrape see absolute http(s) URLs.
 */
export function normalizeTuneSourceUrl(raw) {
  const s = raw != null ? String(raw).trim() : '';
  if (!s) return '';
  if (/^https?:\/\//i.test(s)) return s;
  if (/^[a-z][a-z0-9+.-]*:/i.test(s)) return s;
  if (/^\/\//.test(s)) return `https:${s}`;
  if (/^[a-zA-Z0-9][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}([/?#]|$)/.test(s)) {
    return `https://${s}`;
  }
  return s;
}
